<div class="html-editor-container">
  <dx-html-editor
        valueType="html"
        value="{{_value}}"
        placeholder="{{placeholder}}"
        [customizeModules]="this._readOnly ? customizeQuillModules : undefined"
        (onValueChanged)="onValueChange($event)"
        style="margin-top: 24px; height: 100% !important;"
      >
        <dxo-toolbar [items]="items"></dxo-toolbar>
        <dxo-variables [dataSource]="_variables" [escapeChar]="['{','}']"></dxo-variables>
        <dxo-media-resizing [enabled]="true"> </dxo-media-resizing>
        <dxo-image-upload [tabs]="['file', 'url']" fileUploadMode="base64"></dxo-image-upload>
  </dx-html-editor>
</div>

